const Networking = () => {
  return (
    <div>
      <h1 className="title">Networking </h1>
      <div className="container-border">
        This will be Networking page where it will display people you can reach
        out to people for the jobs you applied to.
      </div>
    </div>
  );
};

export default Networking;
